import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from 'src/app/core/error.service';
import { StoresService } from 'src/app/core/stores.service';

const REQUIRED_COLUMNS = [
  'company_id',
  'business_name',
  'vat',
  'name',
  'phone_prefix',
  'phone_value',
  'owner_email',
  'owner_id',
  'owner_firstname',
  'owner_lastname',
  'email',
  'address_city',
  'address_country',
  'address_line1',
  'address_postal_code',
  'state',
];

export interface BulkCreateResult {
  total: number;
  success: number;
  failed: number;
  errors: Array<{
    row: number;
    error: string;
  }>;
}

@Component({
  selector: 'app-stores-header-bulk-creation-dialog',
  templateUrl: './stores-header-bulk-creation-dialog.component.html',
  styleUrls: ['./stores-header-bulk-creation-dialog.component.scss'],
})
export class StoreHeaderBulkCreationDialogComponent {
  is_csv_upload_running = false;
  file_name?: string;
  text_file?: string;
  show_results = false;
  result?: BulkCreateResult;

  constructor(
    private dialog_ref: MatDialogRef<StoreHeaderBulkCreationDialogComponent>,
    private error_service: ErrorService,
    private store_service: StoresService,
  ) {}

  onCloseClick(): void {
    if (this.show_results) {
      this.dialog_ref.close({ success: true });
    } else {
      this.dialog_ref.close();
    }
  }

  onConfirmClick(): void {
    if (this.isConfirmButtonDisabled()) return;
    this.bulkCreate();
  }

  bulkCreate(): void {
    this.is_csv_upload_running = true;
    this.store_service.bulkCreate(this.text_file!).subscribe({
      next: result => {
        this.result = result.data;
        this.show_results = true;
        this.is_csv_upload_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_csv_upload_running = false;
      },
    });
  }

  onFileLoaded(event: any): void {
    const file: File = event.target?.files[0];
    this.file_name = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      this.text_file = reader.result as string;
      const csv_data = this.parseCSV(this.text_file, ';');
      this.checkCSV(csv_data);
    };
    reader.readAsText(file);
  }

  parseCSV(csvString: string, separator: string): string[][] {
    const rows = csvString.split(/\r?\n/);
    return rows.map(row => {
      return row.split(separator);
    });
  }

  checkCSV(csv_data: string[][]): boolean {
    const columns: string[] = csv_data[0].map(c => {
      return c.toLowerCase();
    });
    const columns_missing: string[] = [];

    let is_file_valid = true;

    REQUIRED_COLUMNS.forEach(req_col => {
      if (!columns.includes(req_col)) {
        columns_missing.push(req_col);
        is_file_valid = false;
      }
    });

    if (!is_file_valid) {
      this.error_service.processApiError('CSV_NOT_VALID', 'columns_missing: ' + columns_missing.join(', '));
      this.dialog_ref.close();
      return false;
    }

    return true;
  }

  isConfirmButtonDisabled(): boolean {
    return !(!this.is_csv_upload_running && !!this.text_file);
  }
}
